import React from 'react'
import { SuggestedInfoContainer } from 'src/component/lets-get-moving/suggested-info-container'
import { BadgeSkeleton } from 'src/component/ui/badge/badge-skeleton'
import { Skeleton } from 'src/component/ui/skeleton'

export const SuggestedSkeleton = (): React.ReactElement => {
  return (
    <div className="rounded-md overflow-hidden">
      <Skeleton className="h-16 bg-primary-gray rounded-none" />
      <div className="relative">
        <Skeleton className="w-full aspect-[6/5] bg-tertiary-grey rounded-none" />
        <SuggestedInfoContainer>
          <Skeleton className="w-24 h-7 bg-primary-gray" />
          <div>
            <Skeleton className="w-48 h-10 bg-primary-gray mb-3" />
            <div className="flex gap-3">
              <BadgeSkeleton />
              <BadgeSkeleton />
            </div>
          </div>
        </SuggestedInfoContainer>
      </div>
    </div>
  )
}
